// Global search state, owned once above every chrome format.
//
// Both the desktop pill and the mobile top-bar icon open the same palette, and
// ⌘K has to work from either — so the open state and the hotkey live here
// rather than inside a trigger, which would bind the listener once per rendered
// trigger and open a palette per format.

import { useCallback, useEffect, useState } from 'react';

/** `enabled: false` unbinds ⌘K and reports the palette closed. */
export function useSearchPalette(enabled: boolean): {
  searchOpen: boolean;
  openSearch: () => void;
  closeSearch: () => void;
} {
  const [searchOpen, setSearchOpen] = useState(false);
  const openSearch = useCallback(() => setSearchOpen(true), []);
  const closeSearch = useCallback(() => setSearchOpen(false), []);

  useEffect(() => {
    if (!enabled) return undefined;
    function onKey(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setSearchOpen((open) => !open);
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [enabled]);

  return { searchOpen: enabled && searchOpen, openSearch, closeSearch };
}
